/* eslint-disable react/no-array-index-key */
import React from 'react';
import { PieChart, Pie } from 'recharts';
import Panel from '../../../shared/components/Panel';
import {withTranslation} from "react-i18next";

const Reputation = ({reputation, loading, onRefresh, t}) => (
  <Panel
    lg={6}
    xl={3}
    md={12}
    title={t('overview.your_reputation.title')}
    subhead={t('overview.your_reputation.subtitle')}
    onRefresh={onRefresh}
    loading={loading}
  >
    <div className="dashboard__current-users">
      <div className="dashboard__current-users-chart">
        <PieChart height={150} width={280}>
          <Pie
            data={createPieChartDataForReputation(reputation)}
            dataKey="value"
            cx={135}
            cy={140}
            startAngle={180}
            endAngle={0}
            innerRadius={100}
            outerRadius={128}
            paddingAngle={0}
          />
        </PieChart>
        <p className="dashboard__current-users-label" title={reputation}>{parseInt(reputation)}</p>
      </div>
      <div className="dashboard__current-users-info">
        <p className="dashboard__current-users-day">
          <span>{t('overview.your_reputation.prev')}</span>
          <span>0</span>
        </p>
        <p className="dashboard__current-users-day">
          <span>{t('overview.your_reputation.next')}</span>
          <span>1</span>
        </p>
      </div>
    </div>
  </Panel>
);

const createPieChartDataForReputation = (reputation) => {

  const decimalPart = (reputation%1)*1000;

  return [
    { value: decimalPart, fill: '#b8e986' },
    { value: 1000-decimalPart, fill: '#f2f4f7' }
  ]
}

export default withTranslation('dashboard')(Reputation);
